import React from 'react';
import { connect } from 'react-redux';
import { Section, Content, Main, FormContent } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Ttolbar } from './../../../components/includes/ui/table';
import { PageService } from './../../../services';

import PageTemplate from './../template';

class PageUpdate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      sending: false,
      page: null
    };
  }

  componentDidMount(){

    this._Find(this.props.match.params.id);

  }

  /*
  ** @Service
  ** @Description: Find
  */

  _Find = (id) => {

    PageService.find(id).then((response) => {

      // @Dispatch
      this.props.Update(response.page);

      // @State
      this.setState({ loading: true, id: id });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error });

    });

  }

  render() {

    const { loading } = this.state;
    const { page }    = this.props;

    return(

        loading && (

          <Section>

            <ToolbarPrimary title="Páginas"/>
            <BreadcrumbItem to='/pages'>Páginas</BreadcrumbItem>
            <BreadcrumbItem to={ `/pages/update/${ page._id }`}>{ page.title }</BreadcrumbItem>

            <Content>
              <Main>

                <Ttolbar title={ page.title }/>

                <FormContent enabledActions>

                  <PageTemplate page={ page }/>

                </FormContent>

              </Main>
            </Content>

          </Section>

        )

    )
  }

}

const mapStateToProps = (state) => {
  return {
    alert: state.Alert,
    page: state.PageUpdate
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
    Update: (data) => {
      dispatch({
        type: 'PAGE_UPDATE',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PageUpdate);
